import { InjectionToken } from '@angular/core';

export interface FileHandler {
    download(base64Data: string, mimeType: string, fileName: string): void | Promise<void>;
    open(base64Data: string, mimeType: string, fileName: string): void | Promise<void>;
}

export const FILE_HANDLER = new InjectionToken<FileHandler>('FILE_HANDLER');
